import { getHandoffUrl } from '@shared/handoff';
import { getEnv } from '@luna/env';
import { useMyProfile } from '@shared/profile';

import { useContacts } from '../useContacts';
import { isMainAddressEditable, isPhysicalPerson, isVisible } from './ProofOfAddressUpdateService';

type ProofOfAddressUpdate = {
    isVisible: boolean;
    externalApplicationUrl: string;
};

export const useProofOfAddressUpdate = (path = ''): ProofOfAddressUpdate => {
    const { data: profile } = useMyProfile();
    const { allEntities: contacts } = useContacts();

    return {
        isVisible: isVisible(
            isPhysicalPerson(profile?.customerSegment),
            isMainAddressEditable(contacts),
        ),
        externalApplicationUrl: getHandoffUrl({
            url: `${getEnv().contactsDataManagementHandoverAddressUpdateUrl}${path}`,
            oidcReady: false,
            targetClientId: 'gstore',
        }),
    };
};
